import { useFormState } from 'react-final-form';
import { PickByType } from '@cast/shared-types';

import { PreparedWorkload } from 'features/workload-optimization';

import { useVpaSelectedSettingName } from '../../../../../_woop-settings/vpaSelectedSettingNameContexts';

import {
  VerticalRightsizingPolicyFormModel,
  WorkloadDetailsFormModel,
} from '../../../_types';
import { StatusChip } from '../../StatusChip';
import { Stack } from '@cast/design-system';

type ContainerArrayField = keyof PickByType<
  VerticalRightsizingPolicyFormModel,
  { isOverridden: boolean }[]
>;

type Props = {
  workload: PreparedWorkload;
  fieldName: ContainerArrayField;
};

export const ContainerSettingsChips = ({ workload, fieldName }: Props) => {
  const { useSettingIsDefault, settingName } = useVpaSelectedSettingName();

  const isDefault = useSettingIsDefault(settingName);

  const { values } = useFormState<WorkloadDetailsFormModel>({
    subscription: { values: true },
  });

  const numOfOverriddenContainers = values.verticalRightsizing.policy[
    fieldName
  ].filter((v) => v.isOverridden).length;

  return (
    <Stack direction="row" gap={8} alignSelf="center">
      <StatusChip
        left="containers/pod"
        right={`${workload.containers.length}`}
        tooltipContent={['Tooltip Item 1', 'Tooltip Item 2']}
      />
      {!isDefault && (
        <StatusChip
          left="overridden"
          right={`${numOfOverriddenContainers}/${workload.containers.length}`}
          tooltipContent={['Tooltip Item 1', 'Tooltip Item 2']}
        />
      )}
    </Stack>
  );
};
